const Footer = () => {
  return (
    <footer className="pb-3 bg-dark d-flex flex-column justify-content-start">
      <div className="container px-4">
        <p className="m-0 text-center text-white ">
          Copyright &copy; Sahbi Kardi 2022
        </p>
      </div>
    </footer>
  );
};
export default Footer;
